import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientId = (state: StoreSchema) =>
    state.client.clientData.clientId
